import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Page from 'marketing-website/components/modules/Page';
import LandingPagesWrap from 'marketing-website/components/modules/LandingPagesWrap';
import ReactIframeResizer from 'react-iframe-resizer-super';

const meta = {
  title: 'Resources | Marvel',
  meta: [
    {
      name: 'description',
      content:
        'A collection of handy resources to get you up and running with Marvel',
    },
    {
      name: 'keywords',
      content: 'Webinars, Tutorials, e-books',
    },
  ],
  header: false,
  footer: false,
};

function Resources({ history, location }) {
  const iframeResizerOptions = {
    checkOrigin: false,
    autoResize: true,
    resizedCallback() {
      // eslint-disable-next-line no-multi-assign
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    heightCalculationMethod: 'lowestElement',
  };

  const slug = `${location.pathname.split('/')[2]}${location.search}`;

  return (
    <Page {...meta}>
      <LandingPagesWrap history={history} showBackButton={false}>
        <ReactIframeResizer
          iframeResizerOptions={iframeResizerOptions}
          iframeResizerEnable
          src={`https://resources.marvelapp.com/${slug}`}
        />
      </LandingPagesWrap>
    </Page>
  );
}

Resources.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object.isRequired,
};
export default withRouter(Resources);



// WEBPACK FOOTER //
// ./src/components/Resource.js